/**
 * Does a version preview currently COVER the live editor?
 *
 * The undo and save guards all key on this one answer, and it is the seam where
 * a whole overlay can go unguarded without anything failing: the per-file
 * version preview and the PDApp app-version preview are separate overlays with
 * separate render conditions, and each one has to be represented here. Adding a
 * third overlay — or splitting one of these conditions — silently drops it out
 * of the guard otherwise, and the editor underneath is still mounted, still
 * editable and still dirty.
 *
 * So: this must stay the exact disjunction of the overlays' render conditions in
 * WorkspaceView. The test beside it pins each one separately for that reason.
 */
export interface VersionPreviewState {
  /** A single file's version being previewed. */
  previewVersionId: string | null
  /** The file whose history panel is open; the per-file overlay needs both. */
  versionPanelFileId: string | null
  /** A PDApp app-version being previewed over the running app (#612). */
  appPreview: { fileId: string; versionId: string } | null
}

export function isVersionPreviewCovering(s: VersionPreviewState): boolean {
  // Per-file preview: the overlay renders only with BOTH, so a half-open state
  // (a version chosen after the panel closed) is not a cover.
  const perFile = !!s.previewVersionId && !!s.versionPanelFileId
  // App-version preview: mutually exclusive with the per-file one, which is why
  // it carries the `!previewVersionId` term rather than standing alone.
  const app = !!s.appPreview && !s.previewVersionId
  return perFile || app
}
